<script setup>
import {ref, onMounted, computed, reactive} from 'vue'
import {getUser, updateUser} from '@/services/api/auth.js'
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import {handleError} from "@/utils/errors.js";
import messageService from '@/services/messages.js'
import {useI18n} from "vue-i18n";
import router from "@/router/index.js";
import {useRoute} from "vue-router";
import {
    getAttributeById,
    saveAttribute,
} from "@/services/api/attribute.js";
import {getManufacturer} from "@/services/api/manufacturer.js";
import EntityForm from "@/components/common/Form.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {AttributeEntity} from "@/entities/AttributeEntity.js";
import {buildPayloadFromEntity, searchAndSetOptions, setFieldOptions} from "@/utils/index.js";
import {getVarTemplates} from "@/services/api/attributeLayout.js";

const { t } = useI18n();
const route = useRoute();
const loading = ref(false);
const id = route.params.id;
const isMounted = ref(false);
const form = ref(null);
const attributeEntity = new AttributeEntity();
const entity = ref(attributeEntity);
const isFetching = ref(false);
const formData = ref(entity.value.getDefaultValues());
const fieldsDisabled = ref(false);

async function handleSearch({ handler, query }) {
    const handlers = {
        handleSearchManufacturer: () =>
            searchAndSetOptions({
                key: "manufacturer_id",
                apiFn: getManufacturer,
                query,
                entity,
                isFetching
            }),
    };

    if (handlers[handler]) {
        await handlers[handler]();
    } else {
        console.warn(`Handler não encontrado: ${handler}`);
    }
}

async function onSave() {
    try {
        const { valid } = await form.value.validate();
        if (!valid) return;

        loading.value = true;

        formData.value.id = id ?? null;
        const payload = buildPayloadFromEntity(entity.value, formData.value);
        payload.id = formData.value.id ?? null;

        await saveAttribute(payload);

        await router.push("/isp/attribute");
        message.success(t("common.messages.success.save"));

    } catch (error) {
        console.error(error);
        message.error(await handleError(error, t, formData?.value?.name));
    } finally {
        loading.value = false;
    }
}

onMounted(async () => {
    try {
        isMounted.value = false;
        const varTemplates = await getVarTemplates();

        setFieldOptions(entity, "default_value", varTemplates.map(item => ({
            label: `{{${item.name}}}`,
            value: `{{${item.name}}}`,
        })));

        if (id) {
            const response = await getAttributeById({ id });
            const data = response.data;
            fieldsDisabled.value = response.data.read_only;
            if (data.manufacturer && typeof data.manufacturer === "object") {
                data.manufacturer_id = {
                    title: data.manufacturer.name,
                    value: data.manufacturer.id
                };
            }

            formData.value = data;
        }

    } catch (error) {
        console.error("Erro ao montar o componente:", error);
    } finally {
        isMounted.value = true;
    }
});

</script>

<template >
    <BasePage :loading-mounted="isMounted" :entity="entity">
        <template #default>
            <EntityForm :entity="entity" v-model="formData" :disabled="fieldsDisabled" ref="form" @search="handleSearch" />
            <ButtonSave :loading="loading"  @click="onSave" />
        </template>
    </BasePage>
</template>

